export default ({ height = 24, width = 24, customClass = '' }) => (
  <svg width={width} height={height} class={customClass} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M12 4L17 9L7 9L12 4ZM12 20L7 15H17L12 20Z' fill='black' />
  </svg>
)
